import { getQueryStringVariable } from './getQueryStringVariable';

export function getBetslipPage(isMobile) {
	const defaultBetslipPage = '/betslip';
	const customBetslipPage = getQueryStringVariable('betslipPage');
	if (isMobile) {
		return customBetslipPage || (window.appConfig && window.appConfig.ROUTES && window.appConfig.ROUTES.prematch && window.appConfig.ROUTES.prematch.betslip) || defaultBetslipPage;
	}else{
		return customBetslipPage || ( window.appConfig?.ROUTES?.betslip?.['betslip'] || window.appConfig.ROUTES.prematch.betslip ) || defaultBetslipPage;
	}
}
